function _setTimeout(ms: number): Promise<void>;
function _setTimeout<T>(ms: number, value: T): Promise<T>;
// biome-ignore lint/suspicious/noConfusingVoidType: <Void is ok>
function _setTimeout<T>(ms: number, value?: T): Promise<void | T> {
	return new Promise((resolve) => {
		setTimeout(() => {
			resolve(value);
		}, ms);
	});
}

export { _setTimeout as setTimeout };
